import { jsx as _jsx } from "react/jsx-runtime";
import { omitThemingProps, styled, useStyleConfig, vui } from '../core';
import { cs } from '../utils';
import { DefinitionContent } from './definitionContent';
/**
 * Properties are definition lists
 * */
// @formatter:off
export const DefinitionVerticalBase = styled.dlBox `
  display: grid;
  gap: 1em;
  grid-template-columns: repeat(auto-fit, minmax(10em, 20em));

  .vui-definitionItemWrapper {
    display: flex;
    flex-direction: column;
  }

  dt,
  dd {
    display: inline-flex;
  }
`;
export const DefinitionHorizontalBase = styled.dlBox `
  padding: 10px;
  display: grid;
  gap: 0;

  .vui-definitionItemWrapper {
    display: flex;
    flex-direction: column;
    @media (min-width: 1024px) {
      flex-direction: row;
    }
  }

  dt,
  dd {
    display: inline-flex;
    padding-left: 5px;
  }

  dd {
    ::after {
      content: '';
    }
    @media (min-width: 1024px) {
      ::after {
        content: ',';
      }
    }
  }

  dt {
    width: 20%;
    min-width: 130px;
  }
`;
// @formatter:on
export const Definition = vui((props, ref) => {
    const { orientation = 'horizontal', className, ...rest } = omitThemingProps(props);
    const styles = useStyleConfig('Definition', props);
    return orientation === 'horizontal' ? (_jsx(DefinitionHorizontalBase, { className: cs('vui-definition vui-definition-horizontal', className), ref: ref, ...styles.container, ...rest, children: _jsx(DefinitionContent, { ...rest }) })) : (_jsx(DefinitionVerticalBase, { className: cs('vui-definition vui-definition-vertical', className), ref: ref, ...styles.container, ...rest, children: _jsx(DefinitionContent, { ...rest }) }));
});
Definition.displayName = 'Definition';
export default Definition;
